import React from 'react';
import PropTypes from 'prop-types';
import {
  CLIENT_RESULTS_COUNT,
  MODELS,
} from 'src/components/Search/constants';
import SearchBarSection from './SearchBarSection';

const SearchBarResults = (props) => (
  <div className="search-results max-w-4xl">
    <SearchBarSection
      displayName="Clients"
      model={MODELS.contact}
      numResults={CLIENT_RESULTS_COUNT}
      scope={props.scope}
    />
  </div>
);

SearchBarResults.propTypes = {
  scope: PropTypes.string.isRequired,
};

export default SearchBarResults;
